import { render } from "./EventGuestHeader.vue?vue&type=template&id=827cdd92&scoped=true&ts=true"
import script from "./EventGuestHeader.vue?vue&type=script&lang=ts"
export * from "./EventGuestHeader.vue?vue&type=script&lang=ts"

import "./EventGuestHeader.vue?vue&type=style&index=0&id=827cdd92&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-827cdd92"]])

export default __exports__